import React, { Component } from 'react';
import css from '/style.scss'
import {Switch} from "react-router-dom";
import {ConnectedRouter as Router} from 'react-router-redux'
import ToastManager from "components/shared/toast";
import {Provider} from "react-redux";
import {ReduxConfig} from "utils/store";
import AppRoute from "utils/route";
import OnlineOffline from 'components/online_offline/index'
import AccountPage from 'components/account_page/index'
import HomePage from 'components/home_page'
import SetupAccountPage from 'components/setup'
import {LoginPage, SignupPage} from 'components/auth/index'
import FaqPage from 'components/faq/index'
import PremiumModal from 'components/subscriptions/modal'
import SettingsPage from 'components/settings'
import PrivacyPage from 'components/privacy'
import FacebookReconnectPage from 'components/setup/reconnect.js'
import {connect} from 'react-redux'
import Footer from 'components/footer/index'
import api from './api'
import PublicAdventurePage from './components/adventures/public/index'
import analytics from 'utils/analytics'
import ForgotPasswordPage from './components/password/forgot'
import ResetPasswordPage from './components/password/reset'
import PlansPage from './components/subscriptions/page'

analytics.init(ReduxConfig.history)

const Routers=(props)=>{
  return (
    <Switch>
      <AppRoute exact path="/" component={HomePage}/>
      <AppRoute path="/c/:uuid" component={PublicAdventurePage}/>
      <AppRoute isPrivate path="/a/:id" component={AccountPage}/>
      <AppRoute exact isPublic path="/signup" component={SignupPage}/>
      <AppRoute exact isPublic path="/login" component={LoginPage}/>
      <AppRoute exact isPublic path="/forgot" component={ForgotPasswordPage}/>
      <AppRoute exact isPublic path="/reset/:token" component={ResetPasswordPage}/>
      <AppRoute exact isPrivate path="/accounts/new" component={SetupAccountPage}/>
      <AppRoute exact isPrivate path="/settings" component={SettingsPage}/>
      <AppRoute exact isPrivate path="/settings/upgrade" component={PlansPage}/>
      <AppRoute exact isPrivate path="/settings/reconnect" component={FacebookReconnectPage}/>
      <AppRoute exact path="/faq" component={FaqPage}/>
      <AppRoute exact path="/privacy" component={PrivacyPage}/>
    </Switch>
  )
}

const _PremiumModal=(props)=>{
  return (
    <div>
      {props.open && <PremiumModal/>}
    </div>
  )
}

const mapStateToProps = function (state) {
  return {
    open:state.ui.premium_modal
  }
}
const LoadPremiumModal=connect(mapStateToProps)(_PremiumModal)


class _Container extends Component{
  componentDidMount(){
    if(this.props.user.authenticated){
      api.getCurrentUser()
    }
  }
  render(){
    return (
      <div className={css.container}>
      {this.props.children}
      </div>
    )
  }
}
const getUser=(state)=>{
  return {user:state.user}
}
const Container=connect(getUser)(_Container)

class App extends Component {
  render() {
    return (
      <Provider store={ReduxConfig.store}>
        <Container>
          <Router history={ReduxConfig.history} basename="/">
            <div>
              <OnlineOffline/>
              <Routers />
              <Footer/>
              <LoadPremiumModal />
              <ToastManager/>
            </div>
          </Router>
        </Container>

      </Provider>


    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js